/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APICarrierPolicy } from '@/models/api/carrier-policy.model'

const resource = {
    main: 'services',
    module: 'carrier-policies'
}

export class CarrierPoliciesServices {
    public static getCarrierPolicies () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getCarrierPoliciesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getCarrierPoliciesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createCarrierPolicies (params: APICarrierPolicy) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editCarrierPolicies (params: APICarrierPolicy) {
        return service.put(`${resource.main}/${resource.module}/${params.carrierPolicyId}`, params)
    }

    public static deleteCarrierPolicies (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreCarrierPolicies (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
